import type { GetServerSideProps, NextPage } from 'next';
import { Frontpage } from '@/components/FrontPage';
import { verticalConfig } from '@/config/verticalConfig';
import { createSspForVertical, type SspProps } from '@/util/verticalSsp';

const FrontPagePrepackage: NextPage<SspProps> = (pageProps) => <Frontpage config={verticalConfig.prepackage} {...pageProps} />;

export const getServerSideProps: GetServerSideProps<SspProps> = createSspForVertical(verticalConfig.prepackage.vertical);

export default FrontPagePrepackage;
